import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CreateOrUpdateSystemIntegrationLoginRequest,
  SystemIntegrationLogin,
  SystemIntegrationLoginPassword,
} from 'brain-data/model/system-integration-login.model';
import {
  CreateOrUpdateSystemIntegrationContactRequest,
  SystemIntegrationContact,
} from 'brain-data/model/system-integration-contact.model';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';

interface SystemIntegrationLoginListResponse {
  data: SystemIntegrationLogin[];
}

@Injectable({
  providedIn: 'root',
})
export class SystemIntegrationService {
  private readonly baseUrl = `${environment.apiBaseAdminUrl}/system-integration-logins`;

  constructor(private http: HttpClient) {}

  getLogins(): Observable<SystemIntegrationLogin[]> {
    return this.http.get<SystemIntegrationLoginListResponse>(`${this.baseUrl}`).pipe(map(response => response.data));
  }

  createLogin(payload: CreateOrUpdateSystemIntegrationLoginRequest): Observable<SystemIntegrationLogin> {
    return this.http.post<SystemIntegrationLogin>(`${this.baseUrl}`, payload);
  }

  updateLogin(id: number, payload: CreateOrUpdateSystemIntegrationLoginRequest): Observable<SystemIntegrationLogin> {
    return this.http.put<SystemIntegrationLogin>(`${this.baseUrl}/${id}`, payload);
  }

  deleteLogin(id: number): Observable<SystemIntegrationLogin> {
    return this.http.delete<SystemIntegrationLogin>(`${this.baseUrl}/${id}`);
  }

  getLoginPassword(id: number): Observable<SystemIntegrationLoginPassword> {
    return this.http.get<SystemIntegrationLoginPassword>(`${this.baseUrl}/${id}/password`);
  }

  getContacts(loginId: number): Observable<SystemIntegrationContact[]> {
    return this.http.get<{ data: SystemIntegrationContact[] }>(`${this.baseUrl}/${loginId}/contacts`).pipe(map(response => response.data));
  }

  createContact(loginId: number, payload: CreateOrUpdateSystemIntegrationContactRequest): Observable<SystemIntegrationContact> {
    return this.http.post<SystemIntegrationContact>(`${this.baseUrl}/${loginId}/contacts`, payload);
  }

  updateContact(
    loginId: number,
    id: number,
    payload: CreateOrUpdateSystemIntegrationContactRequest,
  ): Observable<SystemIntegrationContact> {
    return this.http.put<SystemIntegrationContact>(`${this.baseUrl}/${loginId}/contacts/${id}`, payload);
  }

  deleteContact(loginId: number, id: number): Observable<SystemIntegrationContact> {
    return this.http.delete<SystemIntegrationContact>(`${this.baseUrl}/${loginId}/contacts/${id}`);
  }
}
